import { errors, errcodes, fields, zodcodes } from './errors';
import { auth } from './auth';
import { feed } from './feed';
import { item } from './item';
import { dialog } from './dialog';
import { playlist } from './playlist';
import { editor } from './editor';
import { search } from './search';
import { library } from './library';
import { labels, times } from './labels';
import { landing } from './landing';
import { meta } from './meta';
import { nav } from './nav';
import { settings } from './settings';
import { profile } from './profile';
import { theme } from './theme';
import { ui } from './ui';

/** Every message in the app. Adding a key here is what makes `t('…')` type-check. */
export const STRINGS = {
  ...meta,
  ...labels,
  ...times,
  ...nav,
  ...ui,
  ...theme,
  ...auth,
  ...landing,
  ...settings,
  ...profile,
  ...item,
  ...dialog,
  ...library,
  ...playlist,
  ...editor,
  ...feed,
  ...search,
  ...errors,
  ...errcodes,
  ...zodcodes,
  ...fields,
};

export type MsgKey = keyof typeof STRINGS;
